<template>
  <div class="copy-url">
    <v-text-field
      :id="inputId"
      v-model="url"
      class="copy-url__input"
      outlined
      dense
      hide-details
      readonly
      prepend-inner-icon="mdi-link-variant"
      @click:prepend-inner="copyUrl"
    />
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    inputId: {
      type: String,
      required: true,
    },
  },

  methods: {
    copyUrl() {
      const codeToCopy = document.querySelector(`#${this.inputId}`);
      codeToCopy.setAttribute('type', 'text');
      codeToCopy.select();

      try {
        document.execCommand('copy');
        this.$store.dispatch('snackbar/showSnackbar', {
          message: ['Link skopiowany'],
          type: 'success',
        }, { root: true });
      } catch {
        this.$store.dispatch('snackbar/showSnackbar', {
          message: ['Coś poszło nie tak, spróbuj ponownie'],
          type: 'error',
        }, { root: true });
      }
      window.getSelection().removeAllRanges();
    },
  },
};
</script>

<style lang="scss" scoped>
.copy-url {
  cursor: pointer;

  &__input {
    background: $bg-light;

    &::v-deep .v-icon {
      font-size: 14px;
      color: $primary !important;
      margin-right: 6px;
      margin-top: 7px;
      z-index: 1 !important;

      &.v-icon--disabled {
        color: $primary !important;
      }
    }
  }
}
</style>
